import * as React from "react";

import { ManagePublicPlans } from "../../../components";

export const ManagePublicPlansContainer: React.FC = () => <ManagePublicPlans />;
